<template>
    <div id="userInfo_main" class="ff-inter">
        <template v-if="user.username">
            <div id="userInfo_name" class="noselect">
                {{ user.username }}
            </div>
            <div id="userInfo_context" class="bt bg-main bt-hover-light br-normal" @click="logout">
                <i class="fas fa-sign-out-alt"></i>
            </div>
        </template>
        <loader v-else></loader>
    </div>
</template>

<script>
  import Loader from './loader'
  export default {
    name: 'userInfo',
    components: { Loader },
    props: {

    },
    computed:{
      user(){
        return this.$store.getters['User/get_user']
      },
    },
    methods: {
      logout(){
        this.$store.dispatch('User/logout');
      }
    }
  }
</script>

<style scoped>
    #userInfo_main{
        display: flex;
        align-items: center;
    }
    #userInfo_context{
        margin-left: 5px;
        padding: 10px;
        cursor: pointer;
    }
</style>
